import { defaultConfig } from "../Forms/EntityConfig";

const UPDATE_AMENITY_VALUE = 'locale/admin/bookings/amenity/UPDATE_AMENITY_VALUE';
const UPDATE_AMENITY_VALUES = 'locale/admin/bookings/amenity/UPDATE_AMENITY_VALUES';
const SET_PARENT_CONFIG = 'locale/admin/bookings/amenity/SET_PARENT_CONFIG';
const RESET_AMENITY_FORM = 'locale/admin/bookings/amenity/RESET_AMENITY_FORM';
const AMENITY_FORM_ERRORS_RETURNED = 'locale/admin/bookings/amenity/AMENITY_FORM_ERRORS_RETURNED';

export const updateAmenityValue = (field, value) => ({
    type: UPDATE_AMENITY_VALUE,
    payload: {
        field: field,
        value: value
    }
})

export const updateAmenityValues = (values) => ({
    type: UPDATE_AMENITY_VALUES,
    payload: {
        values: values
    }
})

export const setParentConfig = (configValues) => ({
    type: SET_PARENT_CONFIG,
    payload: {
        configValues: configValues
    }
})

export const amenityFormErrorsReturned = (serverErrors) => ({
    type: AMENITY_FORM_ERRORS_RETURNED,
    payload: {
        serverErrors: serverErrors
    }
})

export const resetAmenityForm = () => ({ type: RESET_AMENITY_FORM })

export const initialState = {
    amenity: {
        id: 0,
        category: null,
        name: '',
        slug: '',
        description: '',
        image: [],
        active: 1,
        configs: [ defaultConfig ],
        tags: [],
        okkami_linked: false,
        limited_configs: false
    },
    parentConfig: {},
    serverErrors: {},
}

export const bookingsAmenityFormReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_AMENITY_VALUE:
            return {
                ...state,
                amenity: {
                    ...state.amenity,
                    [action.payload.field]: action.payload.value
                }
            }

        case UPDATE_AMENITY_VALUES:
            return {
                ...state,
                amenity: {
                    ...state.amenity,
                    ...action.payload.values
                }
            }

        case SET_PARENT_CONFIG:
            return {
                ...state,
                parentConfig: action.payload.configValues
            }

        case RESET_AMENITY_FORM:
            return {
                ...state,
                amenity: {
                    ...initialState.amenity
                }
            }

        case AMENITY_FORM_ERRORS_RETURNED: {
            return {
                ...state,
                serverErrors: action.payload.serverErrors
            }
        }

        default:
            return state;
    }
}
